"use client";

import {
  LocationDynamic as ReactLocationDynamic,
  Location as ReactLocation,
  LocationSolid as ReactLocationSolid,
} from "./deprecated/Location";

export const LocationDynamic = ReactLocationDynamic;
export const Location = ReactLocation;
export const LocationSolid = ReactLocationSolid;
